import { useLayoutEffect } from 'react';
import { lockBodyScroll } from '../methods/dom.js';
import { syncVisualViewportHeightVar } from '../methods/viewportSheet.js';

const useMobileSheetViewportLock = ({ isOpen, freezeOnMobile, disableZoom, }) => {
    useLayoutEffect(() => {
        if (!isOpen || typeof document === "undefined") {
            return;
        }
        const shouldDisableZoom = freezeOnMobile && disableZoom;
        const unlockScroll = lockBodyScroll({
            freezeOnMobile,
            disableZoom: shouldDisableZoom,
        });
        const unsyncViewport = freezeOnMobile
            ? syncVisualViewportHeightVar({
                deferSessionStart: shouldDisableZoom,
            })
            : () => { };
        return () => {
            unlockScroll();
            unsyncViewport();
        };
    }, [disableZoom, freezeOnMobile, isOpen]);
};

export { useMobileSheetViewportLock };
//# sourceMappingURL=useMobileSheetViewportLock.js.map
